

class Bs {

    constructor(config) {
        const defaultConfig = {
            livewire: true,
        }
        this.config = { ...defaultConfig, ...config };
    }

    livewire(method, hook = 'message.processed') {

        // Livewire ist enabled
        if (this.config.livewire) {

            Livewire.hook(hook, (el, component) => {
                this[method]();
            })
        }
    }

    togglePopovers() {
        const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
        const popoverList = popoverTriggerList.map((popoverTriggerEl) => {
            return new bootstrap.Popover(popoverTriggerEl)
        });
        return popoverList;
    }

    toggleTooltips() {
        const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        const tooltipList = tooltipTriggerList.map((tooltipTriggerEl) => {
            return new bootstrap.Tooltip(tooltipTriggerEl)
        });
        return tooltipList;
    }

    tabs() {
        const triggerTabList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tab"]'));
        triggerTabList.forEach(function (triggerEl) {
            triggerEl.addEventListener('shown.bs.tab', function (event) {
                window.dispatchEvent(new Event('resize'));
            });
        });
    }

    scrollToFirstError(invalid = 'is-invalid') {
        const invalidElemets = document.getElementsByClassName(invalid);
        if (invalidElemets && invalidElemets.length) {
            invalidElemets[0].scrollIntoView();
        }
    }

    runAll() {
        this.togglePopovers();
        this.toggleTooltips();
        this.tabs();
        this.scrollToFirstError();
        this.livewire('togglePopovers');
        this.livewire('toggleTooltips');
        this.livewire('scrollToFirstError');
    }
}

module.exports = Bs
